<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device'})"><i class="fas fa-long-arrow-alt-left"></i>&nbsp; <b>Home</b></a>
                    </span>
                </div>
            </div>
            <div class="profile-section pt-2">
                <h6>Log Files</h6>
                <ul>
                    <li v-for="file in logFiles" :key="file">
                        <a
                        :href="`${baseUrl}/kids/${file}`"
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        {{ file }}
                        </a>
                    </li>
                </ul>
            </div>
            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>
<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";

export default {
  name: 'Server Logs',
  components: {
    KidHeader,
    KidFooter
  },
  data() {
    return {
        isDisabled: false,
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        logFiles: [],
        baseUrl: process.env.VUE_APP_API_BASE_URL
    }
  },
  methods: {
    async getServerLogs() {
        await KidsService.getServerLogs()
        .then((response) => {
          this.logFiles = response.data.data;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
    this.getServerLogs();
  },
}
</script>